import { create } from "zustand";
import api from "../api/api";

type Profile = {
    name: string
    email: string
    ic_number: string
    birthday: string
    profile_pic: string | null
    phone: string,
}

type Student = {
    birthday? : string | null
    email? : string | null
    id : number
    is_active? : boolean | null
    name : string | null
    payment_status? : string | null
    profile_pic? : string | null
    student_standard? : string | null
}

interface ProfileStore {
    // util
    loading: boolean
    setLoading: (loading: boolean) => void
    logout: () => void

    // course related
    courses: []
    setCourses: (data: []) => void
    selectedStudent: null | Student
    setSelectedStudent: (data: Student|null) => void
    lastVisitedCourseId: string | null
    setLastVisitedCourseId: (path: string|null) => void
    clearLastVisitedCourse: () => void

    // Academy's Branch Course usage
    selectedBranchName: null | string
    setSelectedBranchName: (data: string|null) => void

    // user profile related
    profile: Profile | null
    fetchProfile: () => Promise<void>
    students: [] | Student[]
    setStudents: (data: Student[]) => void
    fetchStudents: () => Promise<void>
    homePageShow: string
    setHomePageShow: (data: "school"|"academy") => void
    setProfile: (partial: Partial<Profile>) => void

    // cart edit
    cartEdit: any
    setCartEdit: (data: any) => void

    // attendance
    studentName: string|null
    setStudentName: (data:string|null)=> void
}

export const useProfileStore = create<ProfileStore>((set) => ({
    // util
    loading: false,
    setLoading: (loading) => {
        set({ loading })
    },
    logout:()=> {
        localStorage.removeItem("parent_token")
        localStorage.removeItem("parent_user")
        localStorage.removeItem("selectedStudent")
    },

    // course related
    courses: [],
    setCourses: (data) => set({ courses: data }),
    selectedStudent: null,
    setSelectedStudent: (data: Student|null) => {
        console.log("setSelectedStudent", data)
        set({ selectedStudent: data })
    },
    lastVisitedCourseId: null,
    setLastVisitedCourseId: (path) => set({ lastVisitedCourseId: path }),
    clearLastVisitedCourse: () => set({ lastVisitedCourseId: null }),


    // Academy's Branch Course usage
    selectedBranchName: null,
    setSelectedBranchName: (data: string|null) => {
        set({ selectedBranchName: data })
    },

    // user profile related
    profile: null,
    students: [],
    setStudents: (data: Student[]) => set({ students: data }),
    fetchProfile: async () => {
        console.log("fetch profile")
        try {
            const res = await api.get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`);
            set({ profile: res.data.data })
        } catch (err) {
            console.error("Failed to fetch profile:", err);
        }
    },
    fetchStudents: async () => {
        console.log("fetch students")
        try {
            const res = await api.get(`${process.env.REACT_APP_API_BASE_URL}/student`);
            const students = res.data.result.data
            set({ homePageShow: "academy" })

            // check if all students have school_id
            if (students.length > 0) {
                for (let student of students) {
                    if (student.school_id) {
                        set({
                            homePageShow: "school",
                            selectedStudent: student
                        })
                        break
                    }
                }
            }

            set({ students })
            return students
        } catch (err) {
            console.error("Failed to fetch students:", err)
            return []
        }
    },
    homePageShow: "academy",
    setHomePageShow: (data: "school"|"academy") => set({ homePageShow: data }),
    setProfile: (partial) => {
        set((state) => ({
            profile: state.profile ? { ...state.profile, ...partial } : null,
        }))
    },

    // cart edit
    cartEdit: null,
    setCartEdit: (data) => set({ cartEdit: data }),

    // attendance
    studentName: null,
    setStudentName: (data) => set({ studentName: data }),
}))